module.exports = __webpack_public_path__ + "img/operation-4280-bg-mobile.62ad35a5.png";